import React from 'react';
import Commands from '../components/Commands/Commands';

const CommandsPage: React.FC = () => {
  return (
    <div className="commands-page">
      <Commands />
    </div>
  );
};

export default CommandsPage;
